/** LitHub provenance + source-permission types (F13, F15). */

export type SavedFromSource =
  | 'search'
  | 'digest'
  | 'screen'
  | 'litscholar'
  | 'litportal-library'
  | 'manual'
  | 'unknown';

/**
 * LitArchive Source dropdown — only LitCurrent vs LitPortal.
 * `litpulse` matches any non–LitPortal provenance; `litportal-library` matches LitPortal saves.
 */
export const ARCHIVE_SOURCE_FILTER_OPTIONS = [
  { value: 'litpulse', label: 'LitCurrent' },
  { value: 'litportal-library', label: 'LitPortal' },
] as const;

/** @deprecated Use ARCHIVE_SOURCE_FILTER_OPTIONS */
export const SAVED_FROM_FILTER_OPTIONS: SavedFromSource[] = [
  'screen',
  'litportal-library',
];

export type SourcePermissionBadge =
  | 'ai_summary_eligible'
  | 'link_out_only'
  | 'metadata_only'
  | 'full_text_available'
  | 'uploaded_full_text'
  | 'citation_verified';

export type RankerAdvisoryTag =
  | 'boost'
  | 'demote'
  | 'maintain'
  | 'broader_topic_mapped'
  | 'parallel_ai_candidate';

export interface LibraryArticleRecord {
  pmid: string;
  title: string;
  abstract?: string;
  journal?: string;
  authors?: string;
  pub_date?: string;
  ai_summary?: string;
  specialty_name?: string;
  specialty_id?: string;
  subspecialty_id?: string;
  profile_id?: string;
  design_tags?: string[];
  saved_at?: string;
  folder?: string;
  doi?: string;
  year?: number;
  /** Provenance */
  saved_from?: SavedFromSource;
  source?: string;
  clinical_question?: string;
  search_session_id?: string;
  evidence_packet_id?: string;
  ranker_advisory?: RankerAdvisoryTag;
  source_permission?: 'allowed' | 'restricted' | 'unknown';
  full_text_status?: 'available' | 'unavailable' | 'unknown' | 'uploaded';
  citation_verified?: boolean;
  eligible_for_summary?: boolean;
}

export interface SourcePermissionState {
  badges: SourcePermissionBadge[];
  canAudio: boolean;
  canLitScholar: boolean;
  blockedAudioReason?: string;
  blockedLitScholarReason?: string;
}
